<template>
    <div class="simple-table">
        <table>
            <tr v-for="(row, rowIndex) in content.Rows" :key="rowIndex">
                <td
                    v-for="(rowKey, index) in Object.keys(row)"
                    :key="index"
                    v-html="row[rowKey]"
                ></td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: 'SimpleTable',
    props: {
        content: {
            Headers: Array,
            Rows: Array,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';
.simple-table {
    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        tr td {
            font-weight: 300;
            color: #333;
            padding: 12px 10px;
            background: #fbfcfc;
            border: 1px solid #e4e4e7;
            font-size: 14px;
        }

        tr td:first-child {
            width: 1%;
            white-space: nowrap;
            padding-right: 30px;
            font-weight: 800;
        }

        tr:nth-child(2n) td {
            background: #f5f7f7;
        }
    }
}
</style>
